module.exports = __webpack_public_path__ + "img/rule01.1113b79b.png";